import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import useAxios from './use-axios';

type UseNylasAttachmentDownloadParams = {
  grantId: string;
  attachmentId: string;
  filename: string;
  messageId: string;
};

export function useNylasAttachmentDownload() {
  const axios = useAxios();

  return useMutation({
    mutationFn: async (params: UseNylasAttachmentDownloadParams) => {
      const { grantId, attachmentId, filename, messageId } = params;
      const response = await axios.get(
        `/nylas/attachments/${attachmentId}`,
        {
          params: {
            grantId,
            messageId,
          },
          responseType: 'blob',
        },
      );

      // Create a URL for the blob
      const url = globalThis.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.append(link);
      link.click();
      link.remove();
    },
    onSuccess: () => {
      toast.success('Attachment downloaded');
    },
    onError: (error) => {
      toast.error('Failed to download attachment', {
        description: error.message,
      });
    },
  });
}
